// The new app's videos about moving to it, hosted on Mux. Rendered and kept in the new app's repo
// (docs/videos/<slug>/); the playback IDs here must match frontend/src/docs/videos.ts there.
// Playback IDs are public by design, like any Mux embed.
export const upgradeVideos = {
  whyMove: {
    slug: 'why-move-to-the-new-app',
    title: 'Why move to the new app',
    playbackId: '97VQikI00BV01X3I9h38dtgmfFpS9PajHt01kFcFwIzzP00',
    duration: '1:40'
  },
  moving: {
    slug: 'moving-to-the-new-app',
    title: 'Moving to the new app, step by step',
    playbackId: 'mNq9hAcS014uyqPocW6kbrBaYGUlaHZcFSYbVdTu02Nag',
    duration: '2:00'
  }
}

// Mux Player's embed URL, as the new app builds it (accent in the banner's violet).
export function upgradeVideoUrl (video) {
  const params = [
    'autoplay=true',
    'accent-color=' + encodeURIComponent('#6b32d6'),
    'metadata-video-id=' + encodeURIComponent(video.slug),
    'metadata-video-title=' + encodeURIComponent(video.title)
  ]
  return 'https://player.mux.com/' + video.playbackId + '?' + params.join('&')
}



// WEBPACK FOOTER //
// ./src/apps/vendorconsignment/components/upgradeVideos.js